import { TextWithMd } from '@elements/text/textWithMd';
import { i18n } from '@i18n';

export function UsTravelDatesProtectionModal() {
  return (
    <TextWithMd variant="body-16/m">{i18n.t('travelDates.restrictionModal.content')}</TextWithMd>
  );
}
